(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-new-markdown-sale"] && !Shopify.designMode) return;
  try {
    

/*$('.owl-carousel.new-product-slider').owlCarousel({
    loop:true,
    margin:10,
	navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:3,
            nav:true,
            loop:false
        }
    }
}) */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-new-product-slider"] && !Shopify.designMode) return;
  try {
    

$('.owl-carousel.new-product-slider').owlCarousel({
    loop:true,
    margin:10,
	navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:3,
            nav:true,
            loop:false
        }
    }
})


  } catch(e) { console.error(e); }
})();
})();
